import { useState } from 'react';
import { ComplianceValidationVariant } from '../ComplianceDrawer';

interface SectionStates {
  isKeyTermsExpanded: boolean;
  isErrorsExpanded: boolean;
  isSuccessesExpanded: boolean;
  isDebugExpanded: boolean;
  isAIComparisonExpanded: boolean;
  isTimestampsExpanded: boolean;
  isClassificationExpanded: boolean;
  isFolderExpanded: boolean;
  isPipelineExpanded: boolean;
  isExtractedFieldsExpanded: boolean;
}

interface SectionActions {
  toggleKeyTerms: () => void;
  toggleErrors: () => void;
  toggleSuccesses: () => void;
  toggleDebug: () => void;
  toggleAIComparison: () => void;
  toggleTimestamps: () => void;
  toggleClassification: () => void;
  toggleFolder: () => void;
  togglePipeline: () => void;
  toggleExtractedFields: () => void;
}

interface UseSectionStatesReturn {
  sectionStates: SectionStates;
  sectionActions: SectionActions;
}

export const useSectionStates = (
  variant: ComplianceValidationVariant,
  shouldExpandPipelineInitially = false
): UseSectionStatesReturn => {
  const [isKeyTermsExpanded, setIsKeyTermsExpanded] = useState(true);
  const [isErrorsExpanded, setIsErrorsExpanded] = useState(true);
  const [isSuccessesExpanded, setIsSuccessesExpanded] = useState(true);
  const [isDebugExpanded, setIsDebugExpanded] = useState(
    variant === 'internal'
  );
  const [isAIComparisonExpanded, setIsAIComparisonExpanded] = useState(
    variant === 'internal'
  );
  const [isTimestampsExpanded, setIsTimestampsExpanded] = useState(
    variant === 'internal'
  );
  const [isClassificationExpanded, setIsClassificationExpanded] = useState(
    variant === 'internal'
  );
  const [isFolderExpanded, setIsFolderExpanded] = useState(
    variant === 'internal'
  );
  const [isPipelineExpanded, setIsPipelineExpanded] = useState(
    shouldExpandPipelineInitially
  );
  const [isExtractedFieldsExpanded, setIsExtractedFieldsExpanded] = useState(
    variant === 'internal'
  );

  const sectionStates: SectionStates = {
    isKeyTermsExpanded,
    isErrorsExpanded,
    isSuccessesExpanded,
    isDebugExpanded,
    isAIComparisonExpanded,
    isTimestampsExpanded,
    isClassificationExpanded,
    isFolderExpanded,
    isPipelineExpanded,
    isExtractedFieldsExpanded,
  };

  const sectionActions: SectionActions = {
    toggleKeyTerms: () => setIsKeyTermsExpanded((prev) => !prev),
    toggleErrors: () => setIsErrorsExpanded((prev) => !prev),
    toggleSuccesses: () => setIsSuccessesExpanded((prev) => !prev),
    toggleDebug: () => setIsDebugExpanded((prev) => !prev),
    toggleAIComparison: () => setIsAIComparisonExpanded((prev) => !prev),
    toggleTimestamps: () => setIsTimestampsExpanded((prev) => !prev),
    toggleClassification: () => setIsClassificationExpanded((prev) => !prev),
    toggleFolder: () => setIsFolderExpanded((prev) => !prev),
    togglePipeline: () => setIsPipelineExpanded((prev) => !prev),
    toggleExtractedFields: () => setIsExtractedFieldsExpanded((prev) => !prev),
  };

  return {
    sectionStates,
    sectionActions,
  };
};
